export enum PrinterNameEnum {
    MASTER ='master',
    EOD_PRINTER = 'eod_printer'
}
export enum PrinterStatus {
    ENABLED ='1',
    DISABLED = '6'
}